import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailRounded from "@mui/icons-material/EmailRounded";
import WifiCalling3Icon from "@mui/icons-material/WifiCalling3";
import ReachUs from "../Contact-us/ReachUs";
import {
  PHONE_NUMBER_ONE,
  PHONE_NUMBER_TWO,
  PHONE_NUMBER_USA,
} from "@/constastants/Constant";

const CardComponent = ({ isNorthAmericaAds = false }) => {
  const [selectedTab, setSelectedTab] = useState(isNorthAmericaAds ? "3" : "1");
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    if (isNorthAmericaAds) {
      setSelectedTab("3");
    } else {
      setSelectedTab("1");
    }
  }, [isNorthAmericaAds]);

  const renderContent = () => {
    switch (selectedTab) {
      case "1":
        return (
          <div className="mt-[-2rem] sm:mt-[0]">
            <Stack mb="1rem" direction="row" gap="1rem">
              <LocationOnIcon className="text-white" />
              <p className="font-normal text-base text-white">
                3rd Floor, A50, Donear House, Cross Road Number 1, Near V R A
                Reality Pvt Ltd, Andheri East, Mumbai, Mumbai Suburban,
                Maharashtra, India 400093
              </p>
            </Stack>

            <Stack mb={"1rem"} direction={"row"} gap={"1rem"}>
              <EmailRounded className="text-white" />
              <a
                href="mailto:info@elchemy.com"
                className="font-normal text-base text-white"
              >
                info@elchemy.com
              </a>
            </Stack>
            <Stack mb={"1rem"} direction={"row"} gap={"1rem"}>
              <WifiCalling3Icon className="text-white" />
              <a
                href={`tel:+${PHONE_NUMBER_ONE.value}`}
                className="font-normal text-base text-white"
              >
                {PHONE_NUMBER_ONE.label}
              </a>
              <a
                href={`tel:${PHONE_NUMBER_TWO.value}`}
                className="font-normal text-base text-white -ml-2"
              >
                {PHONE_NUMBER_TWO.label}
              </a>
            </Stack>
            {/* Add other details for Mumbai */}
          </div>
        );
      case "2":
        return (
          <div className="mt-[-2rem] sm:mt-[0]">
            <Stack mb="1rem" direction="row" gap="1rem">
              <LocationOnIcon className="text-white" />
              <p className="font-normal text-base text-white">
                3/8, 2nd Floor, Asaf Ali Road, Above Dabur India Pvt Ltd, New
                Delhi 110002
              </p>
            </Stack>
            <Stack mb={"1rem"} direction={"row"} gap={"1rem"}>
              <EmailRounded className="text-white" />
              <a
                href="mailto:info@elchemy.com"
                className="font-normal text-base text-white"
              >
                info@elchemy.com
              </a>
            </Stack>
            <Stack mb={"1rem"} direction={"row"} gap={"1rem"}>
              <WifiCalling3Icon className="text-white" />
              <a
                href={`tel:+${PHONE_NUMBER_ONE.value}`}
                className="font-normal text-base text-white"
              >
                {PHONE_NUMBER_ONE.label}
              </a>
              <a
                href={`tel:${PHONE_NUMBER_TWO.value}`}
                className="font-normal text-base text-white -ml-2"
              >
                {PHONE_NUMBER_TWO.label}
              </a>
            </Stack>
            {/* Add other details for New Delhi */}
          </div>
        );
      case "3":
        return (
          <div className="mt-[-2rem] sm:mt-[0]">
            <Stack mb="1rem" direction="row" gap="1rem">
              <LocationOnIcon className="text-white" />
              <p className="font-normal text-base text-white">
                100 Somerset Corporate Blvd, Bridgewater, NJ 08807, USA
              </p>
            </Stack>
            <Stack mb={"1rem"} direction={"row"} gap={"1rem"}>
              <EmailRounded className="text-white" />
              <a
                href="mailto:info@elchemy.com"
                className="font-normal text-base text-white"
              >
                info@elchemy.com
              </a>
            </Stack>
            <Stack mb={"1rem"} direction={"row"} gap={"1rem"}>
              <WifiCalling3Icon className="text-white" />
              <a
                href={`tel:+${PHONE_NUMBER_ONE.value}`}
                className="font-normal text-base text-white"
              >
                {PHONE_NUMBER_USA.label}
              </a>
              {/* <a
                href={`tel:${PHONE_NUMBER_TWO.value}`}
                className="font-normal text-base text-white -ml-2"
              >
                {PHONE_NUMBER_TWO.label}
              </a> */}
            </Stack>
            {/* Add other details for USA */}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Box className="sm:absolute top-0  sm:left-[6rem] sm:mt-[3.8rem]">
        <Card
          className=" w-full md:mt-[-2rem] mt-[-4rem] sm:mt-[0] sm:w-[40rem] min-h-[15rem]"
          style={{
            backgroundColor: "#EF4136",
          }}
        >
          <Tabs
            className=""
            value={selectedTab}
            textColor="white"
            backgroundColor="secondary"
            onChange={handleChange}
            TabIndicatorProps={{
              sx: {
                display: "none",
              },
            }}
            aria-label="full width tabs example"
            sx={{
              bgcolor: "#D83D33",
              width: "100%",
            }}
          >
            <Tab
              sx={{
                "@media (max-width: 600px)": {
                  fontSize: "12px",
                },
                textTransform: "none",

                color: "#fff",
              }}
              value="1"
              className="p-4 w-[33.33%] contactTabBtn  font-medium"
              label="Mumbai"
            />
            <Tab
              textColor="#fff"
              sx={{
                "@media (max-width: 600px)": {
                  fontSize: "12px",
                },
                textTransform: "none",
                color: "#fff",
              }}
              value="2"
              className="p-4 w-[33.33%] contactTabBtn font-medium text-[#fff]"
              label="New Delhi"
            />

            <Tab
              textColor="#fff"
              sx={{
                "@media (max-width: 600px)": {
                  fontSize: "12px",
                },
                textTransform: "none",

                color: "#fff",
              }}
              value="3"
              className="p-4 w-[33.33%] contactTabBtn  font-medium text-[#fff] "
              label="USA"
            />
          </Tabs>
          <div className="m-[3rem]">{renderContent()}</div>
        </Card>
      </Box>
      <div className="pb-20">
        <ReachUs selectedTab={selectedTab} />
      </div>
    </>
  );
};

export default CardComponent;
